import { render, staticRenderFns } from "./ProductStickerAddForm.vue?vue&type=template&id=23ff114c&"
import script from "./ProductStickerAddForm.vue?vue&type=script&lang=ts&"
export * from "./ProductStickerAddForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports